import type { PolyLine2 } from "./polyLine2Types";

export interface AABB2 {
  minX: number;
  minY: number;

  maxX: number;
  maxY: number;
}

/**
 * AABB2 with the minimum area and the rotatedpolyline that achieves it.
 * Rotate the polyline by the -rot angle to get the original polygon.
 */
export interface MinAreaAABB2 extends AABB2 {
  rot: number;
  rotPoly: PolyLine2;
}

export interface MidPointData {
  x: number;
  y: number;
  width: number;
  depth: number;
}

export enum AABB2GridPosition {
  TL = "TL",
  TC = "TC",
  TR = "TR",
  ML = "ML",
  MC = "MC",
  MR = "MR",
  BL = "BL",
  BC = "BC",
  BR = "BR",
}

/**
 * Creates a new AABB2 from min/max coordinates
 */
export function aabb2New(minX: number, minY: number, maxX: number, maxY: number): AABB2 {
  return { minX, minY, maxX, maxY };
}

/**
 * Returns the width of an AABB2
 */
export function aabb2Width(a: AABB2): number {
  return a.maxX - a.minX;
}

/**
 * Returns the height of an AABB2
 */
export function aabb2Height(a: AABB2): number {
  return a.maxY - a.minY;
}
